
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
    <Helmet>
        <title>404 Page Not Found</title>
        <meta name="description" content="Page not found. Let's get you back on track." />
        <link rel="canonical" href="https://youaux.com/404" />
      </Helmet>
    <div className="ophira-bg min-h-screen flex items-center justify-center px-4">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden bg-ophira-texture bg-cover bg-center bg-no-repeat">
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      <div className="bg-ophira-darkgray/80 backdrop-blur-md p-12 md:p-16 text-center max-w-lg relative border border-ophira-yellow/10">
        <h1 className="text-6xl md:text-8xl font-bold mb-4 text-ophira-yellow">404</h1>
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white">Page Not Found</h2>
        <p className="text-ophira-lightgray mb-8">
          We couldn't find the page you were looking for. Let's get you back on track.
        </p>
        <Link to="/">
          <Button className="ophira-button">
            <Home size={18} className="mr-2" /> Return Home
          </Button>
        </Link>
      </div>
    </div>
    </>
  );
};

export default NotFound;
